
const user = {
  state: {
    name: '',
    avatar: '',
    status: '',
    realName: '',
    phone: '',
    activeBar:0,
    activeGoods:0,
    activeLabel:'home'
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REALNAME: (state, realName) => {
      state.realName = realName
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ACTIVEBAR: (state,active) => {
      state.activeBar = active
    },
    SET_ACTIVEGOODS: (state,active) => {
      state.activeGoods = active
    },
    SET_LABBAR: (state,active) => {
      state.activeLabel = active
    }
  },

  actions: {

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js